import React, { useState, useRef } from 'react';
import { Input, Button, Spin, message, Tag } from 'antd';
import { deptReportApi, DeptReportRow } from '../../services/deptReportApi';

const P1306Form: React.FC = () => {
  const [startCode, setStartCode] = useState('');
  const [endCode, setEndCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<DeptReportRow[]>([]);
  const [total, setTotal] = useState(0);
  const [queried, setQueried] = useState(false);
  const printRef = useRef<HTMLDivElement>(null);

  const handleQuery = async () => {
    const s = startCode.trim();
    const e = endCode.trim() || (s ? (s + 'zzzz').substring(0, 4) : 'zzzz');
    if (e < s) {
      message.error('部門代號輸入範圍錯誤，後者不可小於前者!');
      return;
    }
    setLoading(true);
    try {
      const res = await deptReportApi.query(s, e);
      setData(res.data || []);
      setTotal(res.total);
      setQueried(true);
      if ((res.data || []).length === 0) message.info('查無資料!');
    } catch {
      message.error('查詢失敗');
    } finally {
      setLoading(false);
    }
  };

  const handleStartBlur = () => {
    if (startCode.trim() && !endCode.trim()) {
      setEndCode((startCode.trim() + 'zzzz').substring(0, 4));
    }
  };

  const handlePrint = () => {
    if (!printRef.current) return;
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    const now = new Date().toLocaleString('zh-TW');
    printWindow.document.write(`<!DOCTYPE html><html><head><title>部門清冊</title>
<style>
  body { font-family: 'Microsoft JhengHei', sans-serif; margin: 20px; }
  h2 { text-align: center; margin-bottom: 4px; }
  .meta { text-align: center; font-size: 12px; color: #666; margin-bottom: 12px; }
  table { width: 100%; border-collapse: collapse; font-size: 13px; }
  th, td { border: 1px solid #333; padding: 4px 8px; }
  th { background: #f0f0f0; text-align: center; }
  td { text-align: left; }
  .center { text-align: center; }
  @media print { body { margin: 10mm; } }
</style></head><body>
<h2>部門清冊</h2>
<div class="meta">查詢範圍: ${startCode.trim() || '(全部)'} ~ ${endCode.trim() || '(全部)'}　　列印時間: ${now}　　共 ${total} 筆</div>
<table>
<thead><tr><th style="width:80px">部門代號</th><th>部門名稱</th><th style="width:100px">主管代號</th><th style="width:60px">狀態</th></tr></thead>
<tbody>${data.map(r => `<tr>
  <td class="center">${r.f106_01}</td>
  <td>${r.f106_11}</td>
  <td class="center">${r.f106_12}</td>
  <td class="center">${r.f106_16 ? '舊' : '有效'}</td>
</tr>`).join('')}</tbody>
</table>
</body></html>`);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <Spin spinning={loading}>
      <div className="max-w-3xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">部門清冊 (pw1306f1)</h2>

        <div className="flex items-center gap-3 mb-4">
          <label className="text-sm">部門代號 [從]</label>
          <Input value={startCode} onChange={e => setStartCode(e.target.value)} onBlur={handleStartBlur}
            maxLength={4} style={{ width: 100 }} placeholder="起始" />
          <label className="text-sm">[至]</label>
          <Input value={endCode} onChange={e => setEndCode(e.target.value)}
            maxLength={4} style={{ width: 100 }} placeholder="結束" />
          <Button type="primary" onClick={handleQuery}>查詢</Button>
          {data.length > 0 && <Button onClick={handlePrint}>列印預覽</Button>}
        </div>

        {queried && (
          <div className="mb-2 text-sm text-gray-500">共 {total} 筆</div>
        )}

        <div ref={printRef}>
          <table className="w-full border-collapse text-sm" style={{ borderSpacing: 0 }}>
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-2 py-1 text-center" style={{ width: 80 }}>部門代號</th>
                <th className="border border-gray-300 px-2 py-1 text-left">部門名稱</th>
                <th className="border border-gray-300 px-2 py-1 text-center" style={{ width: 100 }}>主管代號</th>
                <th className="border border-gray-300 px-2 py-1 text-center" style={{ width: 60 }}>狀態</th>
              </tr>
            </thead>
            <tbody>
              {data.map(r => (
                <tr key={r.f106_01}>
                  <td className="border border-gray-300 px-2 py-1 text-center">{r.f106_01}</td>
                  <td className="border border-gray-300 px-2 py-1">{r.f106_11}</td>
                  <td className="border border-gray-300 px-2 py-1 text-center">{r.f106_12}</td>
                  <td className="border border-gray-300 px-2 py-1 text-center">
                    {r.f106_16 ? <Tag color="default">舊</Tag> : <Tag color="green">有效</Tag>}
                  </td>
                </tr>
              ))}
              {data.length === 0 && queried && (
                <tr><td colSpan={4} className="border border-gray-300 px-2 py-4 text-center text-gray-400">查無資料</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Spin>
  );
};

export default P1306Form;
